export function convertVttToJson(vttString: any) {
  const sections: any[] = parseVttToSections(vttString);
  return convertSectionsToJson(sections);
}

function convertSectionsToJson(sections: any[]) {
  sections.forEach(section => {
    const strs = section.part.split();
    const results = strs.map(function(s: any) {
      return s.replace(/(<([0-9:.>]+)>)/gi, function(n: any) {
        return n.split('').reduce(function(s: any, i: any) {
          return `==${n.replace('<', '').replace('>', '')}`;
        }, 0);
      });
    });
    const cleanArray = cleanText(results[0]).split(' ');
    const resultsArray: any[] = [];
    cleanArray.forEach(function(item: any) {
      if (item.indexOf('==') > -1) {
        const splitedLine = item.split('==');
        const key = splitedLine[0];
        const value = splitedLine[1];
        if (key == '' || key == '##') 
          return;
        
        resultsArray.push({
          word: cleanWord(key),
          time: timeString2ms(value)
        });
      } else 
        resultsArray.push({
          word: cleanWord(item),
          time: undefined
        });
      
    });
    section.words = resultsArray;
    section.part = cleanText(section.part);
  });
  return sections;
}

function parseVttToSections(vttString: any) {
  const sections: any[] = [];
  let current: any = {};
  let start = false;
  const vttArray = vttString.trim().split('\n');
  vttArray.forEach((line: string, index: number) => {
    const cleanedLine = cleanText(line);
    if (cleanedLine !== ' ' && cleanedLine !== '') 
      if (line.indexOf('-->') !== -1) {
        start = true;
        if (current.start) 
          sections.push(clone(current));
        

        const splitedLine = line.split('-->');
        const lineStart = trimRight(splitedLine[0])
          .split(' ')
          .pop();

        const lineEnd = trimLeft(splitedLine[1])
          .split(' ')
          .shift();
        
        current = {
          start: timeString2ms(lineStart),
          end: timeString2ms(lineEnd),
          part: ''
        };
      } else {
        if (start) 
          if (sections.length !== 0) {
            if (cleanText(sections[sections.length - 1].part) !== cleanedLine) {
              if (current.part.length === 0) 
                current.part = line;
              else 
                current.part = `${current.part} ${line}`;
              
              // If it's the last line of the subtitles
              if (index === vttArray.length - 1) 
                sections.push(clone(current));
              
            }
          } else {
            current.part = line;
            sections.push(clone(current));
            current.part = '';
            current.start = 0;
          }
        
      }
    
  });

  return sections;
}

function cleanText(text: string): string {
  return text.replace(/<\/?[^>]+(>|$)/g, '');
}

// helpers
//   http://codereview.stackexchange.com/questions/45335/milliseconds-to-time-string-time-string-to-milliseconds
function timeString2ms(a: any): number {
  // time(HH:MM:SS.mss) // optimized
  let b: any = undefined;
  return (
    (a = a.split('.')), // optimized
    (b = a[1] * 1 || 0), // optimized
    (a = a[0].split(':')),
    b +
      (a[2]
        ? a[0] * 3600 + a[1] * 60 + a[2] * 1
        : a[1]
          ? a[0] * 60 + a[1] * 1
          : a[0] * 1) *
        1e3
  ); // optimized
}

// removes everything but characters and apostrophe and dash
function cleanWord(word: any) {
  return word.replace(/[^0-9a-z'-]/gi, '').toLowerCase();
}

function trimLeft(text: string) {
  return text.replace(/^\s+/, '');
}

function trimRight(text: string) {
  return text.replace(/\s+$/, '');
}

export function clone(obj: any) {
  if (null == obj || 'object' != typeof obj) return obj;
  const copy = obj.constructor();
  for (const attr in obj) 
    copy[attr] = obj[attr];
  
  return copy;
}
